import React, { Component } from 'react';

export default class CoBrandingImage extends Component {
  render() {
    const { findLogoUrl, joinLogoUrl, brandLogoImageUrl, brandColor } = this.props.portfolio;
    const logoUrl = findLogoUrl || brandLogoImageUrl || joinLogoUrl;

    if (!logoUrl) {
      return null;
    }

    return (
      <section className="home-co-branded-image" style={{ backgroundColor: brandColor }}>
        <img className="home-co-branded-image__logo" src={logoUrl} />
      </section>
    );
  }
}
